module.exports = __webpack_public_path__ + "img/patrulla_gnacional_up.06d2b3a2.svg";